import React from 'react';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from './AdminDashboard';
import { Box, Typography, Alert } from '@mui/material';

const AdminPage = () => {
  const { hasPermission } = useAuth();

  if (!hasPermission('is_staff')) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Alert severity="error">
          <Typography variant="h6" gutterBottom>
            Access Denied
          </Typography>
          <Typography>
            You don't have permission to access the admin dashboard.
          </Typography>
        </Alert>
      </Box>
    );
  }

  return <AdminDashboard />;
};

export default AdminPage; 